@if (component) {
<div class="_onItems m-b-2 m-b-7-s">
    @if (component?.title) {
    <h3 class="center"
        [sizeClass]="'XL:h1, MS:h3'">
        <href [link]="component.titleLink">
            <span *iCms="'title' of component"></span>
        </href>
    </h3>
    }
    <div class="p1 center m-t-2 m-t-4-s"
         *iCms="'subtitle' of component; skipEmpty: true"></div>
    @if (component.ctaText && component.ctaLink) {
    <div class="w-12 right center-s m-t-3-s">
        <href [link]="component.ctaLink"
              class="button-inline">
            <span *iCms="'cta_text' of component"></span>
        </href>
    </div>
    }
</div>
}
<div class="snpt-wdgt--widget_loader "
     #instagramFeedRefContainer>
</div>